import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";

export class RegExportadorItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RegExportadorItemViewModel[];
}

export class RegExportadorItemViewModel {

    public Id: number;

    public NIF: string = '';

    public RazonSocial: string = '';

    public Direccion: string = '';

    public IdPais: number;

    public IdPaisDescripcion: string = '';    

    public IdProvincia: number;

    public IdProvinciaDescripcion: string = '';
    
    public IdMunicipio: number;

    public IdMunicipioDescripcion: string = '';    

    public CodigoZip: string = '';

    public Activo: string = '';

    public FechaAlta: Date;

    public FechaBaja: Date | null;

    public FechaCaducidadBaja: Date | null;

    public FechaUltimaExportacion: Date | null;

    public Observaciones: string = '';


}

export class FilterSearchingRegExportadorViewModel extends FilterSearchingBaseViewModel {    

    public NIF: string = '';

    public RazonSocial: string = '';

    public Direccion: string = '';

    public IdPais: number | null = null;

    public IdProvincia: number | null = null;

    public IdMunicipio: number | null = null;

    public CodigoZip: string = '';

    public Activo: number = EnumSiNoTodos.TODOS;

    public FechaAlta: Date | null = null;

    public FechaBaja: Date | null = null;

    public FechaCaducidadBaja: Date | null = null;

    public FechaUltimaExportacion: Date | null = null;
    
}

export class RegExportadorViewModel {

    public Id: number;

    public NIF: string = '';

    public RazonSocial: string = '';

    public Direccion: string = '';

    public IdPais: number;

    public IdProvincia: number;

    public IdMunicipio: number;

    public CodigoZip: string = '';

    public Activo: boolean;

    public FechaAlta: Date;

    public FechaBaja: Date | null;

    public FechaCaducidadBaja: Date | null;

    public FechaUltimaExportacion: Date | null;

    public Observaciones: string = '';

    
    
}


